import React from "react";

import { FormProvider, UseFormReturn } from "react-hook-form";

import Typography from "@mui/material/Typography";

import StyledFormInput from "components/FormInput/FormInput";
import StyledFormCheckbox from "components/FormInput/FormCheckbox";

import { CancelReason, FormValues } from "./validation";

interface Step2Props {
  methods: UseFormReturn<FormValues>;
}

const options = [
  CancelReason.MissingFunctionality,
  CancelReason.CompexInterface,
  CancelReason.ChooseOtherService,
  CancelReason.NoSupport,
  CancelReason.Other,
];

const Step2: React.FC<Step2Props> = ({ methods }) => {
  const reason = methods.watch("reason");

  return (
    <>
      <Typography variant="body1" color="grey800" sx={{ mb: 2 }}>
        Ми хотіли б знати, чому ви вирішили покинути нас. Це допоможе нам
        покращити наш сервіс.
      </Typography>
      <FormProvider {...methods}>
        <StyledFormCheckbox options={options} name="reason" />
        {reason.includes(CancelReason.Other) && (
          <StyledFormInput name="notes" multiline rows={4} fullWidth />
        )}
      </FormProvider>
    </>
  );
};

export default Step2;
